// A shell line, coloured: the command (and the one after a pipe) in amber, flags in blue, pipes quiet, the rest ink.
// Colours live in site-ui.css (.sh-cmd, .sh-flag, .sh-op).

export function ShellCode({ children }: { children: string }) {
  let cmd = true;
  return (
    <>
      {children.split(/(\s+)/).map((t, i) => {
        if (!t.trim()) return t;
        let cls = 'sh-arg';
        if (t === '|' || t === '&&' || t === ';') (cls = 'sh-op'), (cmd = true);
        else if (cmd) (cls = 'sh-cmd'), (cmd = false);
        else if (t.startsWith('-')) cls = 'sh-flag';
        return (
          <span key={i} className={cls}>
            {t}
          </span>
        );
      })}
    </>
  );
}
